export default __webpack_public_path__ + "static/media/Image-21.fca6ef19.jpg";